import { ReducerRegistry } from 'store';
import { SET_ACTIVE_DROPDOWN } from 'store/types';

const INIT_STATE = {
  expandedId: null,
};

export const dropdownReducer = ReducerRegistry.register(
  'dropdown',
  (state = INIT_STATE, action) => {
    switch (action.type) {
      case SET_ACTIVE_DROPDOWN:
        return {
          ...state,
          expandedId: action.payload,
        };
      default:
        return state;
    }
  },
);
